import * as React from 'react';
import $ from 'jquery';
import '../css/footer-message-banner.sass';

interface FooterMessageBannerProps {
  children: React.ReactNode;
  id?: string;
  className?: string;
}

export default function FooterMessageBanner(props: FooterMessageBannerProps) {
  const footerMessageRef: any = React.useRef();

  React.useEffect(() => {
    /* istanbul ignore else */
    if (footerMessageRef && footerMessageRef.current) {
      $('#campfirefooter>.footer-message-banner').remove();
      $('#campfirefooter').prepend($(footerMessageRef.current).detach());
      footerMessageRef.current.style.height = 'auto';
    }
  }, []);

  return (
    <div
      style={{ height: '0px' }}
      ref={footerMessageRef}
      id={props.id}
      className={`footer-message-banner${
        props.className ? ` ${props.className}` : ''
      }`}
    >
      <div>{props.children}</div>
    </div>
  );
}
